import { type Guard } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { UnstakePledgeReviewAtom } from '@capsicum/socios-core';
import { useAtomValue } from 'jotai';

import { useBaseWCPledgeGuard } from './useBaseWCPledgeGuard';

export const useWCPledgeUnstakeReviewGuard: Guard = () => {
	const baseGuard = useBaseWCPledgeGuard();
	const router = useRouter();
	const hasUnstakeReviewData = Boolean(useAtomValue(UnstakePledgeReviewAtom).teamId);

	return {
		onDenied: () => {
			if (baseGuard.status === 'denied') {
				baseGuard.onDenied();
			} else if (!hasUnstakeReviewData) {
				router.push('/locker-room-internationals?tab=activity');
			}
		},
		status: baseGuard.status === 'allowed' && hasUnstakeReviewData ? 'allowed' : 'denied'
	};
};
